/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalOffice_requestGetPortalOffice } from '../models/api_portalOffice_requestGetPortalOffice';
import type { api_portalOffice_requestImportIbowOfficeAndAgreement } from '../models/api_portalOffice_requestImportIbowOfficeAndAgreement';
import type { api_portalOffice_requestSearchPortalOffices } from '../models/api_portalOffice_requestSearchPortalOffices';
import type { api_portalOffice_requestUpdatePortalOffice } from '../models/api_portalOffice_requestUpdatePortalOffice';
import type { api_portalOffice_requestUpdatePortalOfficePublish } from '../models/api_portalOffice_requestUpdatePortalOfficePublish';
import type { api_portalOffice_responseGetPortalOffice } from '../models/api_portalOffice_responseGetPortalOffice';
import type { api_portalOffice_responseImportIbowOfficeAndAgreement } from '../models/api_portalOffice_responseImportIbowOfficeAndAgreement';
import type { api_portalOffice_responseSearchPortalOffices } from '../models/api_portalOffice_responseSearchPortalOffices';
import type { api_portalOffice_responseUpdatePortalOffice } from '../models/api_portalOffice_responseUpdatePortalOffice';
import type { api_portalOffice_responseUpdatePortalOfficePublish } from '../models/api_portalOffice_responseUpdatePortalOfficePublish';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalOfficeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get PortalOffice
     * Get PortalOffice
     * @returns api_portalOffice_responseGetPortalOffice responseGetPortalOffice
     * @throws ApiError
     */
    public postPortalOfficeGet({
        body,
    }: {
        /**
         * requestGetPortalOffice
         */
        body: api_portalOffice_requestGetPortalOffice,
    }): CancelablePromise<api_portalOffice_responseGetPortalOffice> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Import Ibow Office And Agreement Info
     * iBowの事業所情報と法人情報を取り込む
     * @returns api_portalOffice_responseImportIbowOfficeAndAgreement responseImportIbowOfficeAndAgreement
     * @throws ApiError
     */
    public postPortalOfficeImportIbowOfficeAndAgreement({
        body,
    }: {
        /**
         * requestImportIbowOfficeAndAgreement
         */
        body: api_portalOffice_requestImportIbowOfficeAndAgreement,
    }): CancelablePromise<api_portalOffice_responseImportIbowOfficeAndAgreement> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office/import_ibow_office_and_agreement',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Portal Office Publish Status
     * Updates the publish status of a portal office
     * @returns api_portalOffice_responseUpdatePortalOfficePublish Successful response
     * @throws ApiError
     */
    public postPortalOfficePublish({
        body,
    }: {
        /**
         * requestUpdatePortalOfficePublish
         */
        body: api_portalOffice_requestUpdatePortalOfficePublish,
    }): CancelablePromise<api_portalOffice_responseUpdatePortalOfficePublish> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office/publish',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Portal Office Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalOffices
     * 名前またはコードで、承認済みのポータルオフィスを検索する
     * @returns api_portalOffice_responseSearchPortalOffices responseSearchPortalOffices
     * @throws ApiError
     */
    public postPortalOfficeSearch({
        body,
    }: {
        /**
         * requestSearchPortalOffices
         */
        body: api_portalOffice_requestSearchPortalOffices,
    }): CancelablePromise<api_portalOffice_responseSearchPortalOffices> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office/search',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update PortalOffice
     * Update PortalOffice
     * @returns api_portalOffice_responseUpdatePortalOffice responseUpdatePortalOffice
     * @throws ApiError
     */
    public postPortalOfficeUpdate({
        body,
    }: {
        /**
         * requestUpdatePortalOffice
         */
        body: api_portalOffice_requestUpdatePortalOffice,
    }): CancelablePromise<api_portalOffice_responseUpdatePortalOffice> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office/update',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
